<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item>财务管理</el-breadcrumb-item>
            <el-breadcrumb-item>资金管理</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search-box">
            <div class="balance-box">
                <div class="hd">现金余额(元)</div>
                <div class="bd text-primary">
                    {{balance}}
                </div>
            </div>
            <div class="btn-box">
                <el-button type="primary" size="large" @click="goPage('/index/pay/charge')">充值</el-button>
                <el-button type="default" size="large" @click="goPage('/index/finance/cash')">提现</el-button>
            </div>
            <div class="vertical-divider" v-if="ladder !== 0"></div>
            <div class="award-box" v-if="ladder !== 0">
                <div class="hd">奖励余额(元)</div>
                <div class="bd text-primary">
                    {{award}}
                </div>
            </div>
        </div>
        <div class="content-box">
            <div class="table-caption">
                <div class="caption">最近交易</div>
                <div class="handler">
                    <el-button type="text" class="btn-handler" @click="goPage(`/index/finance/fee`)">
                        查看明细
                    </el-button>
                </div>
            </div>
            <div class="table" style="padding-top: 15px;">
                <el-table
                    :data="records"
                    :border="true"
                    :stripe="true"
                >
                    <el-table-column
                        prop="create_time"
                        align="center"
                        label="创建时间">
                    </el-table-column>
                    <el-table-column
                        prop="order_no"
                        align="center"
                        label="交易流水号/结算批次号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="交易类型">
                        <template slot-scope="scope">
                            {{types[scope.row.type]}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="交易金额">
                        <template slot-scope="scope">
                            {{scope.row.money}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="account_money"
                        align="center"
                        label="账户结余">
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
    name: 'Index',
    inject: ['back', 'goPage', 'tel'],
    data () {
        return {
            types: ['充值', '支付服务费', '支付平台服务费', '服务费退款', '平台服务费退款', '提现', '提现失败', '发放奖励'],
            balance: 0,
            records: [],
            total_page: 1,
            award: 0,
            ladder: 0
        }
    },
    computed: {
        ...mapState({
            currentPage: 'curPage',
            condition: 'formFilter'
        })
    },
    mounted () {
        if (this.condition) {
            this.formFilter = this.condition
        }
        this.getCapital()
    },
    methods: {
        getCapital (page = this.currentPage) {
            this.$http.get('/api/user/account/capital', {
                params: {
                    page,
                    size: 10
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.records = res.data.listData
                        this.balance = res.data.use_money
                        this.total_page = res.data.total_page
                        this.award = res.data.award_money
                        this.ladder = res.data.ladder
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        onPageChange (e) {
            this.$store.commit('changePage', e)
            this.getCapital(e)
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/style/var.scss";
@import "../../assets/style/sub.scss";

    .data-overview {
        height: 78px;
    }

    .table-caption {
        padding: 15px 15px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: -10px;
        .caption {
            font-size: 16px;
            font-weight: bold;
            position: relative;
            padding-left: 15px;
            &::before {
                content: "";
                width: 4px;
                height: 20px;
                background-color: $--color-primary;
                position: absolute;
                left: 0;
                top: -2px;
            }
        }
        .handler {
            .btn-handler {
                font-weight: bold;
                font-size: 14px;
            }
        }
    }

    .sub-page {
        .search-box {
            display: flex;
            align-items: flex-end;
            padding: 30px 20px 40px;

            .bd {
                line-height: 1;
                font-size: 28px;
                margin-top: 20px;
            }

            .balance-box {
                margin-right: 55px;
                padding-left: 15px;
            }

            .btn-box {
                margin-right: 120px;
                .el-button {
                    min-width: 140px;

                    & + .el-button {
                        margin-left: 30px;
                    }
                }
            }

            .vertical-divider {
                height: 80px;
                width: 1px;
                background-color: #EBEEF5;
                position: relative;
                top: 10px;
            }

            .award-box {
                padding-left: 60px;
            }
        }
    }
</style>
